import useUserHook from 'hooks/useUserHook';

import { useMutationCreatePoapView } from 'api/mutations/createPoapView.mutation';
import { useMutationDeletePoapView } from 'api/mutations/deletePoapView.mutation';
import { useMutationDuplicatePoapView } from 'api/mutations/duplicatePoapView.mutation';
import { useMutationRenamePoapViewName } from 'api/mutations/renamePoapViewName.mutation';
import { useMutationSetPrivacyMode } from 'api/mutations/setPrivacyMode.mutation';
import { useMutationSetViewSettings } from 'api/mutations/setViewSettings.mutation';
import { useMutationSetVisibilityMode } from 'api/mutations/setVisibilityMode.mutation';
import { useMutationUpdatePoapView } from 'api/mutations/updatePoapView.mutation';
import { useQueryGetFilterItemOptionsByRowType } from 'api/queries/getFilterItemOptionsByRowType.query';
import { useQueryGetFilterReferencesOptions } from 'api/queries/getFilterReferencesOptions.query';
import { useQueryGetPoapPrimaryViews } from 'api/queries/getPoapPrimaryViews.query';
import { useQueryGetPoapSecondaryViews } from 'api/queries/getPoapSecondaryViews.query';
import { useQueryGetPoapViewById } from 'api/queries/getPoapViewById.query';
import { useQueryGetProgramGeneralHierarchyList } from 'api/queries/getProgramGeneralHierarchyList.query';
import { useQueryGetProgressMeasurementMethods } from 'api/queries/getProgressMeasurementMethods.query';
import { useQueryGetRowTypeOptions } from 'api/queries/getRowTypeOptions.query';

export type UseViewsManagerProvider = ReturnType<typeof useViewsManagerProvider>;
export const useViewsManagerProvider = () => {
    const { customerId, username } = useUserHook();
    return {
        api: {
            createNewView: {
                instance: useMutationCreatePoapView(),
            },
            deleteView: {
                instance: useMutationDeletePoapView(),
            },
            duplicateView: {
                instance: useMutationDuplicatePoapView(),
            },
            getPrimaryViews: {
                instance: useQueryGetPoapPrimaryViews({ customerId, username }),
            },
            getSecondaryViews: {
                instance: useQueryGetPoapSecondaryViews({ customerId, username }),
            },
            setPrivacyMode: {
                instance: useMutationSetPrivacyMode(),
            },
            setVisibilityMode: {
                instance: useMutationSetVisibilityMode(),
            },
            renameViewName: {
                instance: useMutationRenamePoapViewName(),
            },
            getProgramGeneralHierrarchyList: {
                instance: useQueryGetProgramGeneralHierarchyList('ProgramLibraryUploadFiles'),
            },
            getRowTypeOptions: {
                instance: useQueryGetRowTypeOptions(),
            },
            getProgressMeasurementMethods: {
                instance: useQueryGetProgressMeasurementMethods(),
            },
            getFilterItemOptions: {
                instance: useQueryGetFilterItemOptionsByRowType,
            },
            getFilterReferencesOptions: {
                instance: useQueryGetFilterReferencesOptions,
            },
            updatePoapView: {
                instance: useMutationUpdatePoapView(),
            },
            getPoapViewById: {
                instance: useQueryGetPoapViewById,
            },
            setViewSettings: {
                instance: useMutationSetViewSettings(),
            },
        },
    };
};
